import React, { Component } from 'react';
import { Page, Layout, Banner, Card, FormLayout, TextField, Button, LegacyStack } from '@shopify/polaris';
import { SkeletonPageCustom } from './SkeletonPageCustom';

export class UnpaidDashboard extends Component {

    constructor(props) {
        super(props);
        props.setIsLoading(true);
        this.state = { loading: true, errorMessage: '', shopName: '', code: '', shopNameError: '', url: window.location.search };
    }

    componentDidMount() {
        this.populateData();
    }

    render() {
        const errorMessage = this.state.errorMessage ? (
            <p>{this.state.errorMessage}</p>
        ) : null;
        return (
            this.state.loading ?
                <SkeletonPageCustom />
                :
                <Page>
                    <Layout>
                        <Layout.Section>
                            <Banner
                                title="REQUIRED: Pick your Plan"
                                status="warning"
                                action={{
                                    content: 'Activate your plan', onAction: () => {
                                        const params = new URLSearchParams(this.state.url);
                                    const shop = params.get("shop");
                                    const host = params.get("host");
                                    window.open('/plans?shop=' + shop + '&host=' + host, '_self');
                                    }
                                }}
                            >
                                <p> Your free trial has expired. To enjoy all of Sticky add to cart bar Booster Pro's features, get a plan today. </p>
                            </Banner>
                        </Layout.Section>
                    </Layout>
                </Page>
        );
    }

    async populateData() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if(typeof(params.redirect) !== undefined && params.redirect){
            this.setState({common: {username:''}});
            this.setState({url:params.redirect})
        }
        
        // const response = await fetch('account/GetRechargeSubscriptionLink');
        // const data = await response.json();
        // console.log('recharge link:',data);
        this.props.setIsLoading(false);
        this.setState({ loading: false });
    }

    
}